(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/mapKeys', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/mapKeys'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.mapKeys, global.convert);
    global.mapKeys = mod.exports;
  }
})(this, function (exports, _mapKeys2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.mapKeys = undefined;

  var _mapKeys3 = _interopRequireDefault(_mapKeys2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an object with the same values as the former object and values generated by running each own enumerable string keyed property of the former object thru <code>iteratee</code>.
   * The iteratee is invoked with three arguments: (value, key, object).
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {function} [iteratee={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @example mapKeys({ nested: { a: 1, b: 2, c: 3 } }, 'nested', (v, k) => '_' + k) // => { nested: { _a: 1, _b: 2, _c: 3 } }
   * @see {@link https://lodash.com/docs#mapKeys|lodash.mapKeys} for more information.
   * @since 0.3.0
   */
  var mapKeys = (0, _convert.convert)(_mapKeys3.default);
  exports.mapKeys = mapKeys;
  exports.default = mapKeys;
});